import React from "react";
import { cn } from "@/lib/utils";
import { AgentMessage } from "@/models/agent/message";

interface StatusMessageProps {
  message: AgentMessage;
  className?: string;
}

const StatusMessage: React.FC<StatusMessageProps> = ({ message, className }) => {
  const content = message.content.message as string;

  return (
    <div className={cn("flex justify-start", className)}>
      <div className="flex items-center space-x-1 text-gray-500">
        <div className="font-normal animate-pulse">
          {content}
          <span className="ml-[2px] tracking-widest">...</span>
        </div>
      </div>
    </div>
  );
};

export default StatusMessage;
